import Layout from './component/Layout';
import TodoApp from './component/todo/TodoApp';
//import TodoTest from './component/todotest/TodoTest';

function App() {
  return (
    <Layout>
    <TodoApp/>    
    </Layout>
    //<TodoTest />
  );
}

export default App;
